import { createContext, useContext, useEffect, useState } from "react";
import { fetchGrupaRoba } from "../services/grupaRoba";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { GrupaRoba } from "../types/GrupaRoba";

interface GrupaRobaContextType {
    gruparoba: GrupaRoba[];
    refreshGrupaRoba: () => Promise<void>;
}

const GrupaRobaContext = createContext<GrupaRobaContextType | undefined>(undefined);

export const GrupaRobaProvider = ({ children }: { children: React.ReactNode }) => {
    const [gruparoba, setGrupaRoba] = useLocalStorage<GrupaRoba[]>("roba", []);

    useEffect(() => {
        if (gruparoba.length === 0) {
            refreshGrupaRoba();
        }
    }, []);

    const refreshGrupaRoba = async () => {
        const data = await fetchGrupaRoba();
        if (data.length > 0) {
            setGrupaRoba(data);
        }
    };

    return (
        <GrupaRobaContext.Provider value={{ gruparoba, refreshGrupaRoba }}>
            {children}
        </GrupaRobaContext.Provider>
    );
};

export const useGrupaRobaContext = () => {
    const context = useContext(GrupaRobaContext);
    if (!context) {
        throw new Error("useGrupaRobaContext must be used within a GrupaRobaProvider");
    }
    return context;
};
